/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;flex-flow:column;justify-content:space-between;width:460px}file-list[_ngcontent-%COMP%]{margin-top:16px}.pages[_ngcontent-%COMP%]{border-top:1px solid #cfd8dc;box-sizing:border-box;display:block;margin:16px 0 12px;padding:16px 0 0;text-align:right}.pages[hidden][_ngcontent-%COMP%]{visibility:hidden}.actions[_ngcontent-%COMP%]{align-items:center;display:flex;justify-content:space-between}.actions[_ngcontent-%COMP%]   button.more[_ngcontent-%COMP%]{margin-left:-8px}"];
export { styles as styles };
